export const Text = {
    variants: {
        // body1 is missing because it's just the default Text
        body2: {
            fontSize: "sm",
        },
    },
}
